import { Td, Text, Tr } from '@chakra-ui/react';
import { memo } from 'react';
import { format } from 'date-fns';

export function ItemComponent({ item }) {
  if (!item) return null;

  return (
    <Tr key={item.id}>
      <Td>{item.razao_socialforn}</Td>
      <Td>{format(new Date(item.data_negociacao), 'dd/MM/yyyy HH:mm')}</Td>
      <Td>{item.codigo_produto}</Td>
      <Td textTransform="capitalize">{item.descricao}</Td>
      <Td textAlign="center">
        <Text
          textDecoration="underline"
          color="blue.500"
          _hover={{ filter: 'brightness(.9)' }}
          as="a"
          href={item.link_nfe_venda}
          target="_blank">
          {item.nfe_venda}
        </Text>
      </Td>
      <Td textAlign="center">
        <Text
          textDecoration="underline"
          color="blue.500"
          _hover={{ filter: 'brightness(.9)' }}
          as="a"
          href={item.link_nfe_compra}
          target="_blank">
          {item.nfe_compra}
        </Text>
      </Td>
      <Td textAlign="center">
        <Text
          textDecoration="underline"
          color="blue.500"
          _hover={{ filter: 'brightness(.9)' }}
          as="a"
          href={item.link_pedido}
          target="_blank">
          {item.ped_venda}
        </Text>
      </Td>
      <Td textAlign="center">
        <Text
          textDecoration="underline"
          color="blue.500"
          _hover={{ filter: 'brightness(.9)' }}
          as="a"
          href={item.link_pedido_compra}
          target="_blank">
          {item.numero_nota}
        </Text>
      </Td>
      <Td>{item.dt_compra}</Td>
      <Td>{item.ncm}</Td>
      <Td>{item.cod_forn}</Td>
      <Td>{item.cor}</Td>
      <Td>{item.qtd}</Td>
      <Td>{item.vlr_unit}</Td>
      <Td>{item.vlr_total}</Td>
      <Td>{item.desc}</Td>
      <Td>{item.vlr_liq}</Td>
      <Td>{item.vlr_imp}</Td>
      <Td>{item.tot_imp}</Td>
      <Td>{item.porc_imp} %</Td>
      <Td color={item.colorDifal}>{item.difal}</Td>
      <Td>{item.cest}</Td>
      <Td>{item.outras_despesas}</Td>
      <Td>{item.valor_sub}</Td>
      <Td>{item.base_icms}</Td>
      <Td>{item.fcp_st}</Td>
    </Tr>
  );
}

export const Item = memo(ItemComponent, (prevProps, nextProps) => {
  return Object.is(prevProps.product, nextProps.product); // return true or false
});
